import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule, PaginatePipe, PaginatePipeArgs } from 'ngx-pagination';
import { HProductControllerService } from '../../api/services';
import { Router } from '@angular/router';
import { SessionService } from '../../common/session.service';
import { HttpErrorResponse } from '@angular/common/http';
import { PagedModelHProductDTO } from '../../api';

@Component({
    selector: 'app-hproduct-list',
    imports: [CommonModule, NgxPaginationModule],
    templateUrl: './hproduct-list.component.html',
    styleUrl: './hproduct-list.component.css'
})
export class HproductListComponent implements OnInit {
    products?: PagedModelHProductDTO;

    // Pagination properties
 pageConfig:PaginatePipeArgs = {
        itemsPerPage: 10,
        currentPage: 1,
        totalItems: 0
    }
 promoterId: number=0;
  message= '';
 messageType: 'text-success' | 'text-danger' = 'text-success';

    constructor( private productService: HProductControllerService,
        private sess: SessionService,
        private router:Router
    ) {}


    ngOnInit() {
      const sess = this.sess.getSessionInfo();
        if(sess.partner?.type=='MERCHANT'){
      this.promoterId =sess.partner?.id!!;
      
    this.loadProductsByPromoter(sess.partner.id!!);
    }
    }

  

    
     onAddProduct(){
        console.log('go to add product');
        this.router.navigateByUrl('/housing/products/add');
    }
    onPageChange(page: number): void {
        console.log('Page changed parent to:', page);
        this.pageConfig.currentPage = page;
        this.loadProductsByPromoter(this.promoterId);
    }

     loadProductsByPromoter(promoterId: number): void {
            this.productService.getProductsByPromoter(  promoterId ,
                 {
                page: Number(this.pageConfig.currentPage)-1,
                size: Number(this.pageConfig.itemsPerPage),
                sort: Array.of('modifiedAt,desc')
                }
            ).subscribe({
                next: (response: PagedModelHProductDTO) => {
                    this.products = response;
                    this.pageConfig.totalItems = response.page?.totalElements?? 0;
    
                    console.debug('Produits chargés avec succès', response);
                },
                error: (error: HttpErrorResponse) => {
                    this.messageType = 'text-danger';
                    this.message = error.error?.message || 'Erreur lors du chargement des produits';
                    console.error('Erreur lors du chargement des produits', error);
                }
            });
        }
}
